<template>
  <div class="loading" v-if="listLoading">
    <a-spin :spinning="listLoading">
    </a-spin>
  </div>
  <a-card class='content' :bordered='false' v-if="statics.scan_award_statistics">
    <h6 class='m-b-25' >数据概况 <span>(数据更新至昨天数据)</span></h6>
    <div class="data-content">
      <div class="data-content-nav s_flex_ali">
        <div class="data-content-nav-item flex_1 s_flex_center active">
          <div>
            <p class='title'><img src="@/assets/images/code/jiangpai.png" alt=""> <span style="margin-right:10px;">奖项发放数量</span>
              <a-tooltip placement="right" title="统计奖项发放数量，即中奖的数量">
                <InfoCircleOutlined />
              </a-tooltip>
            </p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/yestody.png" alt=""><span>{{statics.scan_award_statistics.yesterday}}</span></p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/total.png" alt=""><span>{{statics.scan_award_statistics.total}}</span></p>
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center active">
          <div>
            <p class='title'><img src="@/assets/images/code/huodong.png" alt=""> <span style="margin-right:10px;">活动参与人数</span>
              <a-tooltip placement="right" title="统计所有活动参与人数，包括中奖、未中奖">
                <InfoCircleOutlined />
              </a-tooltip>
            </p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/yestody.png" alt=""><span>{{statics.scan_user_statistics.yesterday}}</span></p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/total.png" alt=""><span>{{statics.scan_user_statistics.total}}</span></p>
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center active">
          <div>
            <p class='title'><img src="@/assets/images/code/saoma.png" alt=""> <span style="margin-right:10px;">扫码量</span>
              <a-tooltip placement="right" title="统计扫码量，包括首次、重复扫码数量">
                <InfoCircleOutlined />
              </a-tooltip>
            </p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/yestody.png" alt=""><span>{{statics.scan_statistics.yesterday}}</span></p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/total.png" alt=""><span>{{statics.scan_statistics.total}}</span></p>
          </div>
        </div>
        <div class="data-content-nav-item flex_1 s_flex_center active">
          <div>
            <p class='title'><img src="@/assets/images/code/shengchan.png" alt=""> <span style="margin-right:10px;">活动参与次数</span>
              <a-tooltip placement="right" title="统计营销活动参与的次数">
                <InfoCircleOutlined />
              </a-tooltip>
            </p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/yestody.png" alt=""><span>{{statics.scan_act_statistics.yesterday}}</span></p>
            <p class="s_flex_bian_c width-50 s_mauto"><img src="@/assets/images/customer/total.png" alt=""><span>{{statics.scan_act_statistics.total}}</span></p>
          </div>
        </div>
      </div>
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="进行中的活动">
            <activity />
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="扫码总量分布">
            <scanMap  :mapData="statics.attend_area_list"/>
          </a-card>
        </a-col>
      </a-row>
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-card title="近7天扫码量">
            <lineCharts :statistics="statics.scan_7_statistics" :key="1" title="近7天扫码量" />
          </a-card>
        </a-col>
        <a-col :span="12">
          <a-card title="近7天活动人数">
            <lineCharts :statistics="statics.user_7_statistics" :key="2" title="近7天活动人数" />
          </a-card>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>
<script>
import { onMounted, ref } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import scanMap from "./components/scanMap/index";
import activity from "./components/activity/index";
import lineCharts from "./components/line/index";
import { showSurvey } from "@/api/qrcodeActivitys.js";
import { iscode } from "../../utils/app";
import {getToday} from '../../libs/util'
export default {
  name: "customer",
  components: { InfoCircleOutlined, scanMap, activity, lineCharts },
  setup() {
    const statics = ref({});
    const listLoading = ref(false);
    const initData = async () => {
      listLoading.value = true;
      let result = await showSurvey()
        .then((res) => res.data)
        .catch((error) => error);
      listLoading.value = false;
      if (iscode(result)) {
        statics.value = result.data;
      } else {
        iscode(result, true);
      }
    };
    const today=ref()
    onMounted(() => {
      initData();
       today.value=getToday()
     
    });
    return {
      statics,
      today,
      listLoading,
    };
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px 15px;
  h6 {
    font-size: 16px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    color: #000;
    span {
      font-size: 12px;
      color: #8e8e8e;
      font-weight: 400;
    }
  }
  .data-content {
    min-height: 643px;
    .data-content-nav {
      background: #fbfcfc;
      border-radius: 10px;
      padding: 10px;
      text-align: center;
      margin-bottom: 30px;
      box-shadow: 3px 2px 2px 0px rgba(27, 66, 108, 0.28);
      .data-content-nav-item {
        color: #8e8e8e;
        font-size: 14px;
        padding-top: 20px;
        padding-bottom: 20px;
        cursor: pointer;
        .title {
          font-size: 16px;
          color: #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 50px;
            height: 50px;
          }
        }
        .num {
          font-size: 34px;
          color: #000;
        }
        img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
        &.active {
          background-color: #fff;
        }
      }
    }
  }
}
.loading {
  width: 100%;
  height: 300px;
  line-height: 300px;
  text-align: center;
}
</style>